<template>
  <ul
    class="jade-stepper"
    v-bind="$attrs"
  >
    <li
      v-for="(step, index) in steps"
      :key="step.name"
      class="jade-stepper__item"
      :data-testid="`item-${index}`"
    >
      <jade-stepper-item
        :icon="step.icon"
        :name="step.name"
        :actived="step.actived"
        :hasNext="index < steps.length - 1"
      />
    </li>
  </ul>
</template>

<script>
import JadeStepperItem from './JadeStepperItem'
export default {
  name: 'JadeStepper',

  components: {
    JadeStepperItem
  },

  props: {
    steps: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.jade-stepper {
  display: flex;
  padding: var(--global-space-150);
  align-items: center;
  justify-content: center;
}
.jade-stepper__item {
  display: flex;
}
</style>
